import { FaHotel, FaMoneyBillWave, FaHeadset, FaMapMarkedAlt } from "react-icons/fa";

export default function WhyChooseUs() {
    const features = [
        {
            icon: <FaHotel size={26} />,
            title: "Premium Hotels",
            desc: "Carefully selected luxury hotels for the best comfort and experience.",
        },
        {
            icon: <FaMoneyBillWave size={26} />,
            title: "Best Price Guarantee",
            desc: "We offer competitive prices with exclusive deals you won’t find elsewhere.",
        },
        {
            icon: <FaHeadset size={26} />,
            title: "24/7 Support",
            desc: "Our team is always ready to assist you anytime, anywhere.",
        },
        {
            icon: <FaMapMarkedAlt size={26} />,
            title: "Top Destinations",
            desc: "Explore the most popular destinations with curated travel options.",
        },
    ];

    return (
        <section className="bg-gradient-to-b from-white to-gray-50 py-12 sm:py-16 lg:py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

                {/* Heading */}
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-3">
                    Why Choose Us
                </h2>

                <p className="text-sm sm:text-base text-gray-500 mb-10 sm:mb-12 max-w-2xl mx-auto">
                    We provide the best travel experience with top services and unbeatable deals
                </p>

                {/* Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 lg:gap-8">
                    {features.map((item, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-2xl shadow-md p-5 sm:p-6 
                            hover:shadow-xl hover:-translate-y-2 transition duration-300 group"
                        >
                            {/* Icon */}
                            <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center mx-auto mb-4 
                            rounded-full bg-gradient-to-r from-teal-500 to-blue-500 text-white 
                            group-hover:scale-110 transition">
                                {item.icon}
                            </div>

                            {/* Title */}
                            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">
                                {item.title}
                            </h3>

                            {/* Description */}
                            <p className="text-sm text-gray-500 leading-relaxed">
                                {item.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}